import React from "react";
import { ArrowUpRight, CheckCircle2 } from "lucide-react";
import { heroBadges, heroImage } from "../mock";

const Hero = ({ onQuote, onContact }) => {
  return (
    <section id="top" className="relative pt-32 md:pt-40 pb-16 md:pb-24 overflow-hidden">
      {/* subtle grid background */}
      <div className="absolute inset-0 bg-grid opacity-[0.4] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="animate-fade-up">
            <p className="text-xs font-semibold tracking-[0.2em] text-neutral-500 uppercase mb-6">
              Nettoyage B2B — Grand Nord de la France
            </p>
            <h1 className="font-heading font-extrabold text-neutral-900 leading-[1.05] text-5xl md:text-6xl lg:text-7xl">
              Des locaux <span className="text-brand">impeccables</span>,
              <br className="hidden md:block" /> une prestation{" "}
              <span className="underline decoration-brand decoration-4 underline-offset-4">
                sans faille
              </span>
              .
            </h1>
            <p className="mt-6 text-lg text-neutral-600 max-w-xl leading-relaxed">
              Entretien de bureaux, bases vie de chantiers et fourniture de
              consommables. Une équipe réactive, des procédures strictes, un
              interlocuteur unique.
            </p>

            <div className="mt-8 flex flex-wrap gap-4">
              <button
                onClick={onQuote}
                className="group bg-brand hover:bg-brand-dark text-white font-semibold px-6 py-3.5 rounded-md flex items-center gap-2 transition-all shadow-sm hover:shadow-lg"
              >
                Demander un devis
                <ArrowUpRight size={18} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </button>
              <button
                onClick={onContact}
                className="border border-neutral-300 hover:border-neutral-900 text-neutral-900 font-semibold px-6 py-3.5 rounded-md transition-colors"
              >
                Nous contacter
              </button>
            </div>

            <div className="mt-10 flex flex-wrap gap-x-6 gap-y-3">
              {heroBadges.map((b) => (
                <div key={b} className="flex items-center gap-2 text-sm text-neutral-600">
                  <CheckCircle2 size={16} className="text-brand" />
                  {b}
                </div>
              ))}
            </div>
          </div>

          <div className="relative animate-fade-up-delayed">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={heroImage}
                alt="Bureaux professionnels nettoyés"
                className="w-full h-[360px] md:h-[440px] object-cover"
              />
              <div className="absolute top-4 right-4 bg-brand text-white text-xs font-bold tracking-widest px-3 py-1.5 rounded-md">
                B2B / 2026
              </div>
            </div>
            <div className="mt-4 bg-white border border-neutral-200 rounded-2xl p-6 shadow-sm flex items-center justify-between">
              <div>
                <p className="text-xs font-semibold tracking-widest text-neutral-500 uppercase">
                  Contrats actifs
                </p>
                <p className="font-heading font-extrabold text-4xl text-neutral-900 mt-1">
                  120+
                </p>
              </div>
              <p className="text-sm text-neutral-500 text-right max-w-[140px]">
                entreprises & chantiers
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
